import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import { ArrayHelperService } from 'src/app/services/common/array-helper.service';
import RecipeNode from '../../subproducts/subproducts-tree/recipe-node';

@Component({
  selector: 'product-type-grid',
  templateUrl: './product-type-grid.component.html',
  styleUrls: ['./product-type-grid.component.scss']
})
export class ProductTypeGridComponent {

  @Input() tree: any[] = [];

  nodes: RecipeNode[] = [];

  @ViewChild("download") downloadLink: ElementRef;

  constructor(private renderer: Renderer2) { }

  ngOnChanges(sc: SimpleChange) {
    if (_.has(sc, 'tree.currentValue') && sc['tree'].currentValue.length > 0) {
      const tree = sc['tree'].currentValue[0];
      this.nodes = tree.getAllNodes();
    }
  }

  downloadList() {
    const csv = this.nodes.map(node => this.nodeToCSV(node)).join("\n");
    this.renderer.setAttribute(this.downloadLink.nativeElement, "href",
      "data:text/plain;charset=utf-8," + csv);
  }

  nodeToCSV(node) {
    return [
      node.product?.PartNumber,
      node.name,
      node.quantity + ' ' + node.product?.MeasurementUnit?.Code,
      node.availability + ' ' + node.availabilityMeasure,
      node.product?.ProductType?.Name?.BG,
      node.product?.CustomProperty_StoreForProdOrder?.Description?.BG,
      node.level,
    ].join(";");
  }
}
